module.exports = __webpack_public_path__ + "static/media/4.a3e32429.jpg";